import { z } from "zod";
/**
 * One server-computed answer to «нужна ли этому лиду квалификация» (owner
 * request 09.10.2026). Rules in priority order, see
 * docs/changes/2026-10-09-unified-qualification.md:
 * circle_watched > quiz_passed > event_skips / event_requires > follow_up_* > events_conflict > default_required.
 * quiz_passed (Ден 28.10.2026): the person's latest site form registration with a quiz was passed.
 * required=null means VEHA cannot decide from data alone; Yana decides from the
 * dialogue by the campaign rules.
 */
export const QualificationDecisionReasonSchema = z.enum([
    "circle_watched",
    "quiz_passed",
    "event_skips",
    "event_requires",
    "follow_up_requires",
    "follow_up_viewing_unknown",
    "events_conflict",
    "default_required",
]);
export const QualificationDecisionSchema = z.object({
    required: z.boolean().nullable(),
    reason: QualificationDecisionReasonSchema,
    explanation: z.string().trim().min(1).max(600),
    decidedAt: z.string().datetime(),
    event: z.object({
        id: z.string().uuid(),
        title: z.string().min(1).max(300),
        date: z.string(),
        phrase: z.string().min(1).max(200),
    }).strict().optional(),
    circleWatchedAt: z.string().datetime().optional(),
    quizPassedAt: z.string().datetime().optional(),
    audioSentAt: z.string().datetime().optional(),
}).strict();
/** Operator line, e.g. «Квалификация: не нужна — посмотрел кружочек Дмитрия (09.10 21:06 МСК)». */
export function qualificationDecisionLine(decision) {
    const verdict = decision.required === true ? "нужна" : decision.required === false ? "не нужна" : "Яна решит по диалогу";
    return `Квалификация: ${verdict} — ${decision.explanation}`;
}
/** GET /api/deals/:dealId/qualification: the decision for the deal's chosen (or latest) chat. */
export const DealQualificationSchema = z.object({
    conversationId: z.string().uuid().nullable(),
    decision: QualificationDecisionSchema.nullable(),
}).strict();
//# sourceMappingURL=qualification.js.map